module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9572.804c3b77.jpg";